module.exports = __webpack_public_path__ + "img/battante.4b317e5.svg";